import { isNodeV2, NodeType, type NodeV2 } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'

import { remapElementId, remapNodeId } from 'services/Store/Project/mutators/node'
import type { MapType } from 'services/Store/Project/types'
import { t } from 'services/Translation'
import { idMapper } from 'utils/editor/clone'

import absolute from './assets/absolute.svg'
import flex from './assets/flex.svg'
import grid from './assets/grid.svg'

export interface IComplexNode {
  root: NodeV2
  nodes?: MapType<NodeV2>
  elements?: MapType<EditorElement>
  image?: string
}

export const isComplexNode = (node?: unknown): node is IComplexNode =>
  !!node && typeof node === 'object' && 'root' in node && isNodeV2(node.root)

export const remapComplexNode = (node: IComplexNode, mapId = idMapper()): IComplexNode => {
  const newRoot = remapNodeId(node.root, mapId)
  const newNodes = Object.entries(node.nodes || {}).reduce((acc, [key, n]) => {
    acc[mapId(key)] = remapNodeId(n, mapId)
    return acc
  }, {} as MapType<NodeV2>)
  const newElements = Object.entries(node.elements || {}).reduce((acc, [key, el]) => {
    acc[mapId(key)] = remapElementId(el, mapId)
    return acc
  }, {} as MapType<EditorElement>)

  return {
    root: newRoot,
    nodes: newNodes,
    elements: newElements,
  }
}

export const NODES: IComplexNode[] = [
  {
    image: flex,
    root: {
      id: '19f709b1-78de-4691-b2a0-b9079b019895',
      type: NodeType.node,
      label: t('editor.flex'),
      style: {
        desktop: {
          position: 'relative',
          display: 'flex',
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
          gridArea: '{"rowStart":5,"rowEnd":8,"colStart":3,"colEnd":7}',
        },
      },
      children: [],
    },
  },
  {
    image: grid,
    root: {
      id: '7cb804de-9808-46c8-8b37-46d4415ebad1',
      type: NodeType.node,
      label: t('editor.grid'),
      style: {
        desktop: {
          position: 'relative',
          display: 'grid',
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
          gridRows:
            '{"min":32,"items":[{"data":{"value":1,"unit":"fr"},"value":"a89977db-04ec-4698-9e65-c0a28d0a7f0c"},{"data":{"value":1,"unit":"fr"},"value":"dba08ebb-2dd1-44fe-b2ca-abb1db0fd8a0"}]}',
          gridArea: '{"rowStart":5,"rowEnd":8,"colStart":3,"colEnd":7}',
        },
      },
      children: [],
    },
  },
  {
    image: absolute,
    root: {
      id: '7cb804de-9808-46c8-8b37-46d4415ebad2',
      type: NodeType.node,
      label: t('editor.absolute'),
      style: {
        desktop: {
          display: 'absolute',
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
        },
      },
      children: [],
    },
  },
  // {
  //   root: {
  //     id: '26e894ad-b142-4f7d-8f58-8862f564e302',
  //     type: NodeType.node,
  //     style: {
  //       desktop: {
  //         gridArea: '{"rowStart":13,"rowEnd":14,"colStart":2,"colEnd":8}',
  //       },
  //     },
  //     children: [],
  //     elementId: 'ef9660ea-cc64-4a89-b974-00753e1101bb',
  //     label: t('editorV2.style.presets.h1'),
  //   },
  //   nodes: {},
  //   elements: {
  //     'ef9660ea-cc64-4a89-b974-00753e1101bb': {
  //       id: 'ef9660ea-cc64-4a89-b974-00753e1101bb',
  //       type: 'richText',
  //       style: {},
  //       font: {},
  //       value: [
  //         {
  //           type: 'heading1',
  //           children: [
  //             {
  //               text: 'Heading 1',
  //             },
  //           ],
  //         },
  //       ],
  //       feedback: {},
  //     },
  //   },
  // },
]
/* {
    root: {
      id: '273f932e-629d-4ec0-8a16-28bb6243c051',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":14,"rowEnd":15,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '2af5dec3-bd00-464d-a479-8f2f699ecfd2',
      label: t('editorV2.style.presets.h2'),
    },
    nodes: {},
    elements: {
      '2af5dec3-bd00-464d-a479-8f2f699ecfd2': {
        id: '2af5dec3-bd00-464d-a479-8f2f699ecfd2',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'heading2',
            children: [
              {
                text: 'Heading 2',
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: 'df06ea63-889a-49cd-833d-8b3e5ecd1a4a',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":15,"rowEnd":16,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '748bdea4-dd99-4dd6-a02e-c53da1a4c24a',
      label: t('editorV2.style.presets.h3'),
    },
    nodes: {},
    elements: {
      '748bdea4-dd99-4dd6-a02e-c53da1a4c24a': {
        id: '748bdea4-dd99-4dd6-a02e-c53da1a4c24a',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'heading3',
            children: [
              {
                text: 'Heading 3',
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: 'b17961c5-d8ef-4d0c-b3ad-f7d8065538af',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":16,"rowEnd":17,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: 'f46e400b-97b0-4c2d-a114-3c6e110505b9',
      label: t('editorV2.style.presets.h4'),
    },
    nodes: {},
    elements: {
      'f46e400b-97b0-4c2d-a114-3c6e110505b9': {
        id: 'f46e400b-97b0-4c2d-a114-3c6e110505b9',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'heading4',
            children: [
              {
                text: 'Heading 4',
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: '5ccac9e2-67d5-4e0a-a3b2-5e4e93de2d84',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":17,"rowEnd":18,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '5925d434-1485-4b4b-8998-39d52289d857',
      label: t('editorV2.style.presets.caption'),
    },
    nodes: {},
    elements: {
      '5925d434-1485-4b4b-8998-39d52289d857': {
        id: '5925d434-1485-4b4b-8998-39d52289d857',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'caption',
            children: [
              {
                text: 'Caption',
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: '28fccde9-fcfa-4685-8091-a099585f5eb4',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":18,"rowEnd":19,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '19301809-ac4b-44cc-a484-d87e06137616',
      label: t('editorV2.style.presets.quote'),
    },
    nodes: {},
    elements: {
      '19301809-ac4b-44cc-a484-d87e06137616': {
        id: '19301809-ac4b-44cc-a484-d87e06137616',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'blockquote',
            children: [
              {
                text: 'Quote',
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: '0ca58c7c-3684-437b-9eca-d78385dbaa75',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":19,"rowEnd":20,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '00df3997-aac5-4bd2-96ad-b39a12111613',
      label: t('editorV2.style.presets.numList'),
    },
    nodes: {},
    elements: {
      '00df3997-aac5-4bd2-96ad-b39a12111613': {
        id: '00df3997-aac5-4bd2-96ad-b39a12111613',
        type: 'richText',
        style: {},
        font: {},
        value: [
          {
            type: 'numberedList',
            children: [
              {
                type: 'listItem',
                children: [
                  {
                    text: 'Numbered',
                  },
                ],
              },
              {
                type: 'listItem',
                children: [
                  {
                    text: 'List',
                  },
                ],
              },
            ],
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: '9b0c03ad-9c5d-410f-a957-e863fbf9cbbf',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":20,"rowEnd":21,"colStart":2,"colEnd":8}',
        },
      },
      children: [],
      elementId: '699247f4-b85d-44c2-83e0-ea8db2dd09b0',
      label: t('editorV2.style.presets.bulList'),
    },
    nodes: {},
    elements: {
      '699247f4-b85d-44c2-83e0-ea8db2dd09b0': {
        id: '699247f4-b85d-44c2-83e0-ea8db2dd09b0',
        type: 'richText',
        style: {},
        font: {},
        feedback: {},
        value: [
          {
            type: 'bulletedList',
            children: [
              {
                type: 'listItem',
                children: [
                  {
                    text: 'Bulleted',
                  },
                ],
              },
              {
                type: 'listItem',
                children: [
                  {
                    text: 'List',
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  },
  {
    root: {
      id: 'fa0a1355-db69-4e16-b1b9-fce5365616e6',
      type: NodeType.node,
      style: {
        desktop: {
          gridArea: '{"rowStart":5,"rowEnd":7,"colStart":3,"colEnd":7}',
          overflow: 'hidden',
          borderRadius:
            '[{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16}]',
          backdropFilter: '{"blur":{"value":10,"on":true}}',
        },
      },
      children: [],
      elementId: 'b93cb687-34d7-4d0e-816f-b2bb84a79868',
      label: t('editorV2.style.presets.glass.button'),
    },
    nodes: {},
    elements: {
      'b93cb687-34d7-4d0e-816f-b2bb84a79868': {
        id: 'b93cb687-34d7-4d0e-816f-b2bb84a79868',
        font: {},
        type: 'button',
        style: {
          desktop: {
            hover: {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            border: {
              borderRadius: 0,
            },
            button: {
              backgroundColor: 'transparent',
            },
          },
        },
        value: {
          label: 'Button',
          actionData: {
            file: {
              id: '',
              source: 'file',
              accessibility: '',
            },
          },
          actionType: 'link',
          thirdLabel: 'Button',
          fourthLabel: 'Button',
          secondLabel: 'Button',
        },
        feedback: {},
      },
    },
  },
  {
    root: {
      id: 'ff28fb89-f5ca-454a-b0d7-1c4e0b9db9d8',
      label: t('editorV2.style.presets.card.profile'),
      type: NodeType.node,
      style: {
        desktop: {
          position: 'relative',
          display: 'flex',
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
          gridArea: '{"rowStart":5,"rowEnd":6,"colStart":2,"colEnd":8}',
          flexAlignItems: 'center',
          flexJustifyContent: 'center',
          padding:
            '[{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8}]',
          borderRadius:
            '[{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8}]',
          overflow: 'hidden',
          background: saveBackground({
            type: 'color',
            color: 'var(--brand-darkBackgroundColor)',
            blendMode: 'normal',
          }),
        },
      },
      children: ['2c3cd472-4bfa-4100-910e-21246a3b8694', '72b91ccf-5807-4c96-94d3-0a960771e75e'],
      isDone: false,
    },
    nodes: {
      '2c3cd472-4bfa-4100-910e-21246a3b8694': {
        id: '2c3cd472-4bfa-4100-910e-21246a3b8694',
        type: NodeType.node,
        style: {
          desktop: {
            width: '{"value":48,"unit":"px"}',
            height: '{"value":48,"unit":"px"}',
            minWidth: null,
            minHeight: null,
            flexGrow: 0,
            borderRadius:
              '[{"unit":"%","value":50},{"unit":"%","value":50},{"unit":"%","value":50},{"unit":"%","value":50}]',
            overflow: 'hidden',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: 'debf0af0-5201-4bc7-ab8c-10024652cd75',
        label: 'Avatar',
      },
      '72b91ccf-5807-4c96-94d3-0a960771e75e': {
        id: '72b91ccf-5807-4c96-94d3-0a960771e75e',
        type: NodeType.node,
        style: {
          desktop: {
            minWidth: '{"unit":"px","value":128}',
            flexGrow: 1,
          },
        },
        children: [],
        elementId: '12021889-af5b-43bf-8305-932b0cc7306c',
        label: 'Name',
      },
    },
    elements: {
      'debf0af0-5201-4bc7-ab8c-10024652cd75': {
        id: 'debf0af0-5201-4bc7-ab8c-10024652cd75',
        font: {},
        type: 'image',
        style: {
          desktop: {
            image: {
              borderRadius: 11,
              objectFit: 'cover',
            },
            effects: {
              boxShadow: '{"preset":"none","size":0,"color":"var(--brand-borderColor)"}',
            },
          },
        },
        feedback: {},
        value: {
          image: {
            id: null,
            source: 'file',
            accessibility: '',
          },
          overlay: '#FFFFFF00',
        },
      },
      '12021889-af5b-43bf-8305-932b0cc7306c': {
        id: '12021889-af5b-43bf-8305-932b0cc7306c',
        font: {
          desktop: {
            base: {
              color: 'var(--brand-lightTextColor)',
              fontSize: 14,
              fontWeight: 700,
            },
          },
        },
        feedback: {},
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'Jack Johnson',
              },
            ],
          },
          {
            type: 'caption',
            children: [
              {
                text: 'Training instructor',
              },
            ],
          },
        ],
      },
    },
  },
  {
    root: {
      id: '849df070-4ff5-4160-afc0-8e9a3008707e',
      type: NodeType.node,
      label: t('editorV2.style.presets.buttons.big'),
      style: {
        desktop: {
          position: 'relative',
          display: 'flex',
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
          gridArea: '{"rowStart":18,"rowEnd":19,"colStart":1,"colEnd":28}',
          flexJustifyContent: 'center',
          gridRows:
            '{"min":32,"items":[{"data":{"value":1,"unit":"fr"},"value":"240fb26d-2c26-4f3f-8381-27da88889351"},{"data":{"value":1,"unit":"fr"},"value":"a02ad489-f58f-470c-8079-54c05e0af522"}]}',
          flexGap: 0,
          minWidth: null,
          minHeight: null,
        },
      },
      children: ['ddf36eb6-7e96-43cd-b000-eed915ebda3f', '5f29e345-49e7-4794-9610-9df6dac2364a'],
    },
    nodes: {
      'ddf36eb6-7e96-43cd-b000-eed915ebda3f': {
        id: 'ddf36eb6-7e96-43cd-b000-eed915ebda3f',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 1,
            width: '{"value":100,"unit":"%"}',
          },
        },
        children: [],
        elementId: 'dbfad2c7-a0b6-4e50-b817-6b0a02adee16',
      },
      '5f29e345-49e7-4794-9610-9df6dac2364a': {
        id: '5f29e345-49e7-4794-9610-9df6dac2364a',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":2,"colStart":1,"rowEnd":3,"colEnd":2}',
            flexGrow: 1,
            width: '{"value":100,"unit":"%"}',
          },
        },
        children: [],
        elementId: '79e6164d-e227-4abc-9ee3-96e05ef8b38f',
      },
    },
    elements: {
      'dbfad2c7-a0b6-4e50-b817-6b0a02adee16': {
        id: 'dbfad2c7-a0b6-4e50-b817-6b0a02adee16',
        type: 'button',
        style: {
          desktop: {
            border: {
              borderRadius: 0,
            },
          },
        },
        font: {},
        feedback: {},
        value: {
          actionType: 'navigation',
          action: 'prevSection',
          label: 'Previous section',
        },
      },
      '79e6164d-e227-4abc-9ee3-96e05ef8b38f': {
        id: '79e6164d-e227-4abc-9ee3-96e05ef8b38f',
        type: 'button',
        style: {
          desktop: {
            border: {
              borderRadius: 0,
            },
          },
        },
        font: {},
        feedback: {},
        value: {
          actionType: 'navigation',
          action: 'nextSection',
          label: 'Next section',
        },
      },
    },
  },
  {
    root: {
      id: '083ff7a1-dbb6-4439-adf9-d3218aa9f5b4',
      type: NodeType.node,
      label: t('editorV2.style.presets.card.glass.light'),
      style: {
        desktop: {
          width: null,
          filter: null,
          height: null,
          display: 'flex',
          opacity: 100,
          padding:
            '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
          position: 'relative',
          boxShadow: 'var(--brand-boxShadow)',
          borderRadius:
            '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
          flexDirection: 'column',
          backdropFilter: '{"blur":{"value":5,"on":true}}',
          background: saveBackground({
            type: 'color',
            color: 'rgba(255, 255, 255, 0.5)',
            blendMode: 'normal',
          }),
          zIndex: 3,
          minWidth: null,
          minHeight: null,
          gridArea: '{"rowStart":3,"rowEnd":4,"colStart":8,"colEnd":14}',
        },
      },
      children: ['7ad6fa4d-9460-499d-a4ab-ea73a2b7e427', '9d5c1686-743c-4dca-9482-4e265db6530b'],
    },
    nodes: {
      '7ad6fa4d-9460-499d-a4ab-ea73a2b7e427': {
        id: '7ad6fa4d-9460-499d-a4ab-ea73a2b7e427',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 1,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: 'bb47e38f-001f-4ab9-809d-aa96f48326ba',
      },
      '9d5c1686-743c-4dca-9482-4e265db6530b': {
        id: '9d5c1686-743c-4dca-9482-4e265db6530b',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: 'aa59d11d-7bfc-4dd5-9739-b53760fb3246',
      },
    },
    elements: {
      'bb47e38f-001f-4ab9-809d-aa96f48326ba': {
        id: 'bb47e38f-001f-4ab9-809d-aa96f48326ba',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      'aa59d11d-7bfc-4dd5-9739-b53760fb3246': {
        id: 'aa59d11d-7bfc-4dd5-9739-b53760fb3246',
        feedback: {},
        font: {
          desktop: {
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            base: {},
            link: {},
            list: {},
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team ',
              },
              {
                type: 'link',
                url: 'asd',
                children: [
                  {
                    text: 'and',
                  },
                ],
              },
              {
                text: ' manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
    },
  },
  {
    root: {
      id: '8df77255-4970-403c-a65b-fea0ead541aa',
      type: NodeType.node,
      label: t('editorV2.style.presets.card.glass.dark'),
      style: {
        desktop: {
          width: null,
          filter: null,
          height: null,
          display: 'flex',
          opacity: 100,
          padding:
            '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
          position: 'relative',
          boxShadow: 'var(--brand-boxShadow)',
          borderRadius:
            '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
          flexDirection: 'column',
          backdropFilter: '{"blur":{"value":5,"on":true}}',
          background: saveBackground({
            type: 'color',
            color: 'rgba(0, 0, 0, 0.5)',
            blendMode: 'normal',
          }),
          zIndex: 3,
          minWidth: null,
          minHeight: null,
          gridArea: '{"rowStart":5,"rowEnd":6,"colStart":2,"colEnd":8}',
        },
      },
      children: ['6ebfaedb-0d1f-46fb-990c-d327e3c5297e', '992a6592-ba46-4d30-bf8b-58befc8f3742'],
    },
    nodes: {
      '6ebfaedb-0d1f-46fb-990c-d327e3c5297e': {
        id: '6ebfaedb-0d1f-46fb-990c-d327e3c5297e',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 1,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: '106e01af-6741-42e3-8227-895e0d3af24d',
      },
      '992a6592-ba46-4d30-bf8b-58befc8f3742': {
        id: '992a6592-ba46-4d30-bf8b-58befc8f3742',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '1929ccba-94db-4295-b7e8-0b442ca6ecc6',
      },
    },
    elements: {
      '106e01af-6741-42e3-8227-895e0d3af24d': {
        id: '106e01af-6741-42e3-8227-895e0d3af24d',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      '1929ccba-94db-4295-b7e8-0b442ca6ecc6': {
        id: '1929ccba-94db-4295-b7e8-0b442ca6ecc6',
        feedback: {},
        font: {
          desktop: {
            h1: {
              color: 'var(--brand-lightTextColor)',
            },
            h2: {
              color: 'var(--brand-lightTextColor)',
            },
            h3: {
              color: 'var(--brand-lightTextColor)',
            },
            h4: {
              color: 'var(--brand-lightTextColor)',
            },
            base: {
              color: 'var(--brand-lightTextColor)',
            },
            link: {
              hoverColor: 'var(--brand-lightTextColor)',
            },
            list: {
              color: 'var(--brand-lightTextColor)',
            },
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
    },
  },
  {
    root: {
      id: '7f693998-bb7e-41db-adf9-2150a7184273',
      type: NodeType.node,
      label: t('editorV2.style.presets.card.accent'),
      style: {
        desktop: {
          width: null,
          filter: null,
          height: null,
          display: 'flex',
          opacity: 100,
          padding:
            '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
          minWidth: null,
          overflow: 'visible',
          position: 'relative',
          boxShadow: 'var(--brand-boxShadow)',
          minHeight: null,
          borderRadius:
            '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
          flexDirection: 'column',
          backdropFilter: null,
          background: saveBackground({
            type: 'color',
            color: 'var(--brand-accentBackgroundColor)',
            blendMode: 'normal',
          }),
          gridArea: '{"rowStart":3,"rowEnd":4,"colStart":2,"colEnd":8}',
          zIndex: 2,
        },
      },
      children: ['e658e4d5-c725-47f3-9240-2ac891def87c', '544d08b8-7cd3-400b-bd2f-2488f2759913'],
    },
    nodes: {
      'e658e4d5-c725-47f3-9240-2ac891def87c': {
        id: 'e658e4d5-c725-47f3-9240-2ac891def87c',
        type: NodeType.node,
        style: {
          desktop: {
            width: '{"value":100,"unit":"%"}',
            height: '{"value":100,"unit":"%"}',
            flexGrow: 1,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            overflow: 'visible',
            flexBasis: null,
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: '5df8ceed-8963-423d-b09e-e95c67413f74',
      },
      '544d08b8-7cd3-400b-bd2f-2488f2759913': {
        id: '544d08b8-7cd3-400b-bd2f-2488f2759913',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 0,
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '49435377-7ace-4b5c-8483-f01be33579ce',
      },
    },
    elements: {
      '5df8ceed-8963-423d-b09e-e95c67413f74': {
        id: '5df8ceed-8963-423d-b09e-e95c67413f74',
        font: {},
        type: 'image',
        style: {
          desktop: {
            image: {
              objectFit: 'contain',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
        feedback: {},
      },
      '49435377-7ace-4b5c-8483-f01be33579ce': {
        id: '49435377-7ace-4b5c-8483-f01be33579ce',
        font: {},
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: '8bfd71fb-5930-4b31-ae45-4fa7a72a6c53',
      type: NodeType.node,
      label: t('editorV2.style.presets.card.light'),
      style: {
        desktop: {
          display: 'flex',
          gridArea: '{"rowStart":4,"colStart":2,"rowEnd":5,"colEnd":8}',
          flexDirection: 'column',
          filter: null,
          backdropFilter: null,
          boxShadow: 'var(--brand-boxShadow)',
          background: saveBackground({
            type: 'color',
            color: 'var(--brand-lightBackgroundColor)',
            blendMode: 'normal',
          }),
          opacity: 100,
          padding:
            '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
          borderRadius:
            '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
          width: null,
          minWidth: null,
          minHeight: null,
          height: null,
          zIndex: 2,
        },
      },
      children: ['7f5a438c-3bb5-4e86-a68d-e2d61f122c8d', '6c5320ac-2fb3-49c2-9fb1-e7d380225fcb'],
    },
    nodes: {
      '7f5a438c-3bb5-4e86-a68d-e2d61f122c8d': {
        id: '7f5a438c-3bb5-4e86-a68d-e2d61f122c8d',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 1,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
            width: '{"value":100,"unit":"%"}',
            height: '{"value":100,"unit":"%"}',
          },
        },
        children: [],
        elementId: 'aea92654-8a97-493e-9d67-b3ccb5a7986f',
      },
      '6c5320ac-2fb3-49c2-9fb1-e7d380225fcb': {
        id: '6c5320ac-2fb3-49c2-9fb1-e7d380225fcb',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '08429fea-5954-4f3b-8a9e-043f721180d9',
      },
    },
    elements: {
      'aea92654-8a97-493e-9d67-b3ccb5a7986f': {
        id: 'aea92654-8a97-493e-9d67-b3ccb5a7986f',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      '08429fea-5954-4f3b-8a9e-043f721180d9': {
        id: '08429fea-5954-4f3b-8a9e-043f721180d9',
        type: 'richText',
        font: {},
        feedback: {},
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
    },
  },
  {
    root: {
      id: 'c8820cfc-3435-4bb3-bb62-a06088b01a07',
      type: NodeType.node,
      label: t('editorV2.style.presets.card.dark'),
      style: {
        desktop: {
          width: null,
          filter: null,
          height: null,
          display: 'flex',
          opacity: 100,
          padding:
            '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
          gridArea: '{"rowStart":4,"colStart":8,"rowEnd":5,"colEnd":14}',
          position: 'relative',
          boxShadow: 'var(--brand-boxShadow)',
          borderRadius:
            '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
          flexDirection: 'column',
          backdropFilter: null,
          background: saveBackground({
            type: 'color',
            color: 'var(--brand-darkBackgroundColor)',
            blendMode: 'normal',
          }),
          minWidth: null,
          minHeight: null,
          zIndex: 2,
        },
      },
      children: ['9a46d26a-d437-4f46-a1ae-dd6124f06241', '16e1cc83-3167-4fb8-9561-09533b37176a'],
    },
    nodes: {
      '9a46d26a-d437-4f46-a1ae-dd6124f06241': {
        id: '9a46d26a-d437-4f46-a1ae-dd6124f06241',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 1,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: '1ce94749-d805-4910-ad2a-4d25e11163d2',
      },
      '16e1cc83-3167-4fb8-9561-09533b37176a': {
        id: '16e1cc83-3167-4fb8-9561-09533b37176a',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '2e66b3a1-684f-49eb-8fc3-97b65334db19',
      },
    },
    elements: {
      '1ce94749-d805-4910-ad2a-4d25e11163d2': {
        id: '1ce94749-d805-4910-ad2a-4d25e11163d2',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      '2e66b3a1-684f-49eb-8fc3-97b65334db19': {
        id: '2e66b3a1-684f-49eb-8fc3-97b65334db19',
        feedback: {},
        font: {
          desktop: {
            h1: {
              color: 'var(--brand-lightTextColor)',
            },
            h2: {
              color: 'var(--brand-lightTextColor)',
            },
            h3: {
              color: 'var(--brand-lightTextColor)',
            },
            h4: {
              color: 'var(--brand-lightTextColor)',
            },
            base: {
              color: 'var(--brand-lightTextColor)',
            },
            link: {
              hoverColor: 'var(--brand-lightTextColor)',
            },
            list: {
              color: 'var(--brand-lightTextColor)',
            },
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
    },
  },
  {
    root: {
      id: 'b88aab62-7da9-4d50-bdd8-7b383dbc3647',
      type: NodeType.node,
      label: t('editorV2.style.presets.borderGradient.border'),
      style: {
        desktop: {
          width: '{"value":100,"unit":"%"}',
          height: '{"value":100,"unit":"%"}',
          display: 'flex',
          flexGap: 12,
          padding:
            '[{"unit":"px","value":12},{"unit":"px","value":12},{"unit":"px","value":12},{"unit":"px","value":12}]',
          background: saveBackground({
            type: 'gradient',
            blendMode: 'normal',
            gradient: {
              type: 'linear',
              angle: 90,
              position: [50, 50],
              stops: [
                { color: 'var(--brand-warningColor)', position: 0 },
                { color: 'var(--brand-infoColor)', position: 100 },
              ],
            },
          }),
          gridArea: '{"rowStart":11,"rowEnd":12,"colStart":2,"colEnd":14}',
          gridRows:
            '{"min":32,"items":[{"data":{"value":1,"unit":"fr"},"value":"be16dc8c-5d38-4340-9479-ee81332f7e73"},{"data":{"value":1,"unit":"fr"},"value":"71dff60e-7978-49b9-a159-beec403d2bf8"},{"data":{"value":1,"unit":"fr"},"value":"0a00251c-b30e-41e7-8c00-3505b7b64833"}]}',
          overflow: 'hidden',
          position: 'relative',
          borderRadius:
            '[{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8},{"unit":"px","value":8}]',
        },
      },
      isDone: false,
      children: [
        '3659eb61-ee9d-4c2f-a91c-2abfa600c2b6',
        '208c2d01-e93e-4fd1-acdd-25a52d7006a3',
        'b3125804-4af5-4e81-b924-dce3ba7f8a4d',
      ],
      repeatable: true,
    },
    nodes: {
      '3659eb61-ee9d-4c2f-a91c-2abfa600c2b6': {
        id: '3659eb61-ee9d-4c2f-a91c-2abfa600c2b6',
        type: NodeType.node,
        label: t('editorV2.style.presets.borderGradient.background'),
        style: {
          desktop: {
            width: '{"value":100,"unit":"%"}',
            height: '{"value":100,"unit":"%"}',
            display: 'flex',
            padding:
              '[{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16}]',
            overflow: 'hidden',
            position: 'relative',
            borderRadius:
              '[{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4}]',
            flexAlignItems: 'center',
            background: saveBackground({
              type: 'color',
              color: 'var(--brand-primaryBackgroundColor)',
              blendMode: 'normal',
            }),
            flexJustifyContent: 'center',
          },
        },
        children: ['4daab8b9-f91f-474a-923a-0ea564d1b324'],
        transform: {
          type: NodeAnimationTypeUiEnum.HOVER,
          value: [
            {
              data: {
                scale: 1,
              },
              value: '813824c7-2140-4e1e-80bd-9e5dd60a821b',
            },
            {
              data: {
                scale: 1.05,
              },
              value: '84b98ada-61a5-4b89-82e2-98811b6fea20',
            },
          ],
          viewport: {
            once: true,
          },
          transition: {
            type: 'tween',
            repeat: 0,
            duration: 0.4,
            repeatType: 'loop',
          },
        },
      },
      '4daab8b9-f91f-474a-923a-0ea564d1b324': {
        id: '4daab8b9-f91f-474a-923a-0ea564d1b324',
        type: NodeType.node,
        style: {
          desktop: {
            zIndex: 1,
            flexGrow: 0,
            overflow: 'hidden',
            borderRadius:
              '[{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null}]',
          },
        },
        children: [],
        elementId: '67f9123e-214e-4142-9f5a-1f1b4f3bcc4a',
      },
      '208c2d01-e93e-4fd1-acdd-25a52d7006a3': {
        id: '208c2d01-e93e-4fd1-acdd-25a52d7006a3',
        type: NodeType.node,
        label: t('editorV2.style.presets.borderGradient.background'),
        style: {
          desktop: {
            width: '{"value":100,"unit":"%"}',
            height: '{"value":100,"unit":"%"}',
            display: 'flex',
            padding:
              '[{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16}]',
            gridArea: '{"rowStart":2,"colStart":1,"rowEnd":3,"colEnd":2}',
            overflow: 'hidden',
            position: 'relative',
            borderRadius:
              '[{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4}]',
            flexAlignItems: 'center',
            background: saveBackground({
              type: 'color',
              color: 'var(--brand-primaryBackgroundColor)',
              blendMode: 'normal',
            }),
            flexJustifyContent: 'center',
          },
        },
        children: ['6e6178d9-6ee0-415c-a301-dc3e0b790fe7'],
        transform: {
          type: NodeAnimationTypeUiEnum.HOVER,
          value: [
            {
              data: {
                scale: 1,
              },
              value: '1137f0d0-5bc8-46df-9e1c-a54b42084fa0',
            },
            {
              data: {
                scale: 1.05,
              },
              value: '9d02f698-d223-4ac2-a6df-030a550398a3',
            },
          ],
          viewport: {
            once: true,
          },
          transition: {
            type: 'tween',
            repeat: 0,
            duration: 0.4,
            repeatType: 'loop',
          },
        },
      },
      '6e6178d9-6ee0-415c-a301-dc3e0b790fe7': {
        id: '6e6178d9-6ee0-415c-a301-dc3e0b790fe7',
        type: NodeType.node,
        style: {
          desktop: {
            zIndex: 1,
            flexGrow: 0,
            overflow: 'hidden',
            borderRadius:
              '[{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null}]',
          },
        },
        children: [],
        elementId: '11ec7bee-24b4-4dbb-b62d-d6751c341d86',
      },
      'b3125804-4af5-4e81-b924-dce3ba7f8a4d': {
        id: 'b3125804-4af5-4e81-b924-dce3ba7f8a4d',
        type: NodeType.node,
        label: t('editorV2.style.presets.borderGradient.background'),
        style: {
          desktop: {
            width: '{"value":100,"unit":"%"}',
            height: '{"value":100,"unit":"%"}',
            display: 'flex',
            padding:
              '[{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16}]',
            gridArea: '{"rowStart":3,"colStart":1,"rowEnd":4,"colEnd":2}',
            overflow: 'hidden',
            position: 'relative',
            borderRadius:
              '[{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4},{"unit":"px","value":4}]',
            flexAlignItems: 'center',
            background: saveBackground({
              type: 'color',
              color: 'var(--brand-primaryBackgroundColor)',
              blendMode: 'normal',
            }),
            flexJustifyContent: 'center',
          },
        },
        children: ['48425448-c390-4d9b-8812-276ddf76eef8'],
        transform: {
          type: NodeAnimationTypeUiEnum.HOVER,
          value: [
            {
              data: {
                scale: 1,
              },
              value: '84ca8d44-b56c-41b2-a96a-0becec975db6',
            },
            {
              data: {
                scale: 1.05,
              },
              value: 'a5b70123-e154-4569-8cf8-a6ab32021aed',
            },
          ],
          viewport: {
            once: true,
          },
          transition: {
            type: 'tween',
            repeat: 0,
            duration: 0.4,
            repeatType: 'loop',
          },
        },
      },
      '48425448-c390-4d9b-8812-276ddf76eef8': {
        id: '48425448-c390-4d9b-8812-276ddf76eef8',
        type: NodeType.node,
        style: {
          desktop: {
            zIndex: 1,
            flexGrow: 0,
            overflow: 'hidden',
            borderRadius:
              '[{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null},{"unit":"px","value":null}]',
          },
        },
        children: [],
        elementId: '417da222-6cd2-4ed7-ae4f-27be05f90e8f',
      },
    },
    elements: {
      '67f9123e-214e-4142-9f5a-1f1b4f3bcc4a': {
        id: '67f9123e-214e-4142-9f5a-1f1b4f3bcc4a',
        font: {},
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'left',
          },
        ],
        feedback: {},
      },
      '11ec7bee-24b4-4dbb-b62d-d6751c341d86': {
        id: '11ec7bee-24b4-4dbb-b62d-d6751c341d86',
        font: {},
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'left',
          },
        ],
        feedback: {},
      },
      '417da222-6cd2-4ed7-ae4f-27be05f90e8f': {
        id: '417da222-6cd2-4ed7-ae4f-27be05f90e8f',
        font: {},
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'left',
          },
        ],
        feedback: {},
      },
    },
  },
  {
    root: {
      id: 'bdc9317d-ce18-4b8f-ace5-4fdbf2cf4419',
      type: NodeType.node,
      label: t('elements.layoutList.label'),
      style: {
        desktop: {
          width: null,
          height: null,
          display: 'flex',
          gridArea: '{"rowStart":6,"colStart":2,"rowEnd":7,"colEnd":14}',
          position: 'relative',
          flexJustifyContent: 'center',
          padding:
            '[{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16},{"unit":"px","value":16}]',
          flexWrap: 'nowrap',
          gridRows:
            '{"min":32,"items":[{"data":{"value":1,"unit":"fr"},"value":"c6c9de2a-7bb9-45ad-8ce3-0b75d283e126"},{"data":{"value":1,"unit":"fr"},"value":"78ca3bfe-54c8-4a3d-819b-e2554d507fd2"},{"data":{"value":1,"unit":"fr"},"value":"c2af5346-9ac5-464c-89c7-dcd4678c44d4"}]}',
          flexDirection: 'row',
          zIndex: 2,
        },
      },
      children: [
        'bd184a63-ef94-41ef-aaf8-81c50904d845',
        '31d8d2e8-5459-4c56-b118-6115be39e091',
        'bbca565f-ab5d-4daf-bf8e-fa8e6e534420',
      ],
      repeatable: true,
    },
    nodes: {
      'bd184a63-ef94-41ef-aaf8-81c50904d845': {
        id: 'bd184a63-ef94-41ef-aaf8-81c50904d845',
        type: NodeType.node,
        label: 'Light glass',
        style: {
          desktop: {
            width: null,
            filter: null,
            height: null,
            display: 'flex',
            opacity: 100,
            padding:
              '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
            position: 'relative',
            boxShadow: 'var(--brand-boxShadow)',
            borderRadius:
              '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
            flexDirection: 'column',
            backdropFilter: '{"blur":{"value":5,"on":true}}',
            background: saveBackground({
              type: 'color',
              color: 'rgba(255, 255, 255, 0.5)',
              blendMode: 'normal',
            }),
            zIndex: 2,
            minWidth: null,
            minHeight: null,
          },
        },
        children: ['9db5a75c-0e71-4170-ac52-c745db2b415d', '0aa3f952-f152-49f6-ac37-1fb525bb695b'],
      },
      '9db5a75c-0e71-4170-ac52-c745db2b415d': {
        id: '9db5a75c-0e71-4170-ac52-c745db2b415d',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 0,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: '541407a5-b18e-4575-b2cf-bdcbaff7145f',
      },
      '0aa3f952-f152-49f6-ac37-1fb525bb695b': {
        id: '0aa3f952-f152-49f6-ac37-1fb525bb695b',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '8cde4d10-a5fd-4aba-b518-e18bbb78614b',
      },
      '31d8d2e8-5459-4c56-b118-6115be39e091': {
        id: '31d8d2e8-5459-4c56-b118-6115be39e091',
        type: NodeType.node,
        label: 'Dark glass',
        style: {
          desktop: {
            width: null,
            filter: null,
            height: null,
            display: 'flex',
            opacity: 100,
            padding:
              '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
            position: 'relative',
            boxShadow: 'var(--brand-boxShadow)',
            borderRadius:
              '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
            flexDirection: 'column',
            backdropFilter: '{"blur":{"value":5,"on":true}}',
            background: saveBackground({
              type: 'color',
              color: 'rgba(0, 0, 0, 0.5)',
              blendMode: 'normal',
            }),
            zIndex: 2,
            minWidth: null,
            minHeight: null,
          },
        },
        children: ['54547a93-5aff-4690-a546-d37351e0c1b7', '4a45c6c8-d1dc-4f33-aed3-f7c354185164'],
      },
      '54547a93-5aff-4690-a546-d37351e0c1b7': {
        id: '54547a93-5aff-4690-a546-d37351e0c1b7',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 0,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: 'ca6aef21-07b5-4abf-914f-4cf299e5a449',
      },
      '4a45c6c8-d1dc-4f33-aed3-f7c354185164': {
        id: '4a45c6c8-d1dc-4f33-aed3-f7c354185164',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: '00c75197-cd0a-4dec-9eef-8836374094e5',
      },
      'bbca565f-ab5d-4daf-bf8e-fa8e6e534420': {
        id: 'bbca565f-ab5d-4daf-bf8e-fa8e6e534420',
        type: NodeType.node,
        label: 'Light glass',
        style: {
          desktop: {
            width: null,
            filter: null,
            height: null,
            display: 'flex',
            opacity: 100,
            padding:
              '[{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"},{"value":24,"unit":"px"}]',
            position: 'relative',
            boxShadow: 'var(--brand-boxShadow)',
            borderRadius:
              '[{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"},{"value":16,"unit":"px"}]',
            flexDirection: 'column',
            backdropFilter: '{"blur":{"value":5,"on":true}}',
            background: saveBackground({
              type: 'color',
              color: 'rgba(255, 255, 255, 0.5)',
              blendMode: 'normal',
            }),
            zIndex: 2,
            minWidth: null,
            minHeight: null,
          },
        },
        children: ['0caf2632-8094-4353-be27-c8daa5a530b9', '270b679d-70dd-47cd-aad1-fde043e1f0ef'],
      },
      '0caf2632-8094-4353-be27-c8daa5a530b9': {
        id: '0caf2632-8094-4353-be27-c8daa5a530b9',
        type: NodeType.node,
        style: {
          desktop: {
            flexGrow: 0,
            gridArea: '{"rowStart":2,"rowEnd":10,"colStart":13,"colEnd":17}',
            minHeight: '{"unit":"px","value":32}',
          },
        },
        children: [],
        elementId: 'd79a5c5a-b9cf-4f6d-9bcf-7b71a7d69a1c',
      },
      '270b679d-70dd-47cd-aad1-fde043e1f0ef': {
        id: '270b679d-70dd-47cd-aad1-fde043e1f0ef',
        type: NodeType.node,
        style: {
          desktop: {
            gridArea: '{"rowStart":10,"rowEnd":16,"colStart":13,"colEnd":17}',
            flexShrink: 0,
          },
        },
        children: [],
        elementId: 'e0abee65-5274-4028-a684-dd596c47e29e',
      },
    },
    elements: {
      '541407a5-b18e-4575-b2cf-bdcbaff7145f': {
        id: '541407a5-b18e-4575-b2cf-bdcbaff7145f',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      '8cde4d10-a5fd-4aba-b518-e18bbb78614b': {
        id: '8cde4d10-a5fd-4aba-b518-e18bbb78614b',
        feedback: {},
        font: {
          desktop: {
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            base: {},
            link: {},
            list: {},
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team ',
              },
              {
                type: 'link',
                url: 'asd',
                children: [
                  {
                    text: 'and',
                  },
                ],
              },
              {
                text: ' manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
      'ca6aef21-07b5-4abf-914f-4cf299e5a449': {
        id: 'ca6aef21-07b5-4abf-914f-4cf299e5a449',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      '00c75197-cd0a-4dec-9eef-8836374094e5': {
        id: '00c75197-cd0a-4dec-9eef-8836374094e5',
        feedback: {},
        font: {
          desktop: {
            h1: {
              color: 'var(--brand-lightTextColor)',
            },
            h2: {
              color: 'var(--brand-lightTextColor)',
            },
            h3: {
              color: 'var(--brand-lightTextColor)',
            },
            h4: {
              color: 'var(--brand-lightTextColor)',
            },
            base: {
              color: 'var(--brand-lightTextColor)',
            },
            link: {
              hoverColor: 'var(--brand-lightTextColor)',
            },
            list: {
              color: 'var(--brand-lightTextColor)',
            },
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team and manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
      'd79a5c5a-b9cf-4f6d-9bcf-7b71a7d69a1c': {
        id: 'd79a5c5a-b9cf-4f6d-9bcf-7b71a7d69a1c',
        type: 'image',
        font: {},
        feedback: {},
        style: {
          desktop: {
            image: {
              objectFit: 'cover',
            },
          },
        },
        value: {
          image: {
            id: null,
            source: 'file',
          },
        },
      },
      'e0abee65-5274-4028-a684-dd596c47e29e': {
        id: 'e0abee65-5274-4028-a684-dd596c47e29e',
        feedback: {},
        font: {
          desktop: {
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            base: {},
            link: {},
            list: {},
          },
        },
        type: 'richText',
        style: {},
        value: [
          {
            type: 'elementDefault',
            children: [
              {
                text: 'You can create your own templates, collaborate with your team ',
              },
              {
                type: 'link',
                url: 'asd',
                children: [
                  {
                    text: 'and',
                  },
                ],
              },
              {
                text: ' manage course development',
              },
            ],
            textAlign: 'center',
          },
        ],
      },
    },
  }, */
